export default __webpack_public_path__ + "static/media/gridicons_quote.f5e5d59f.svg";